import React from "react";
import { FormattedMessage } from "react-intl";

import { PAYERS_TRANSLATION_MAP, PaymentOption } from "~/common/constants";
import { SBCreditComponent } from "~/components/common/common";
import ProbablyFormattedMessage from "~/components/probably_formatted_message";
import { LabelledValue } from "~/components/ui/labelled-value";
import type { TCourseOptionTag, TPatient } from "~/types/patient";

const cbctNoOverpayPaymentOptions: Array<PaymentOption> = [
  PaymentOption.SPLIT_3,
  PaymentOption.SPLIT_3_2,
];
const cbctNoOverpayCourseOptionTag: TCourseOptionTag = "CBCT_V2";
const limitlessNoOverpayCourseOptionTags: Array<TCourseOptionTag> = [
  "LIMITLESS_3_STEPS_V1",
  "LIMITLESS_V2",
  "LIMITLESS_3_STEPS_V2",
];

export function PatientCardPayment({ patient }: { patient: TPatient }) {
  return (
    <div>
      <h3 className="block">
        <FormattedMessage id="BLOCKHEAD_PAYMENT" />
      </h3>

      <LabelledValue label={<FormattedMessage id="HEADER_PAYER" />}>
        <FormattedMessage
          id={patient.payer_id ? PAYERS_TRANSLATION_MAP[patient.payer_id] : "None"}
        />
      </LabelledValue>

      <LabelledValue label={<FormattedMessage id="HEADER_PAYMENT_METHOD" />}>
        <ProbablyFormattedMessage id={patient.course.payment_method} />
      </LabelledValue>

      <LabelledValue label={<FormattedMessage id="HEADER_PAYMENT_OPTION" />}>
        {patient.sber_credit ? (
          <SBCreditComponent showConditions={false} />
        ) : (
          <ProbablyFormattedMessage
            id={
              cbctNoOverpayPaymentOptions.includes(patient.course.payment_option) &&
              (patient.course.course_option_tag == cbctNoOverpayCourseOptionTag ||
                limitlessNoOverpayCourseOptionTags.includes(patient.course.course_option_tag))
                ? "PO_SPLIT_3_NO_OVERPAY"
                : patient.course.payment_option
            }
          />
        )}
      </LabelledValue>

      {patient.promo_code ? (
        <LabelledValue label={<FormattedMessage id="HEADER_PROMO_CODE" />}>
          {patient.promo_code}
        </LabelledValue>
      ) : null}

      <br />

      {patient.logistics_comment ? (
        <LabelledValue label={<FormattedMessage id="CLINIC_SHIP_COMMENTS" />}>
          {patient.logistics_comment}
        </LabelledValue>
      ) : null}
    </div>
  );
}
